import { createFileRoute } from "@tanstack/react-router";
import { WrapAuthRoutes } from "../scaffolding/wrap-auth-routes";

export const Route = createFileRoute("/_auth")({
  component: WrapAuthRoutes,
});
